export const ILLUSTRATIONS_STYLES = {
    'astronaut': 'astronaut.svg',
    /**
     * @deprecated
     * use "black car" instead
     */
    'blac kcard': 'black card.svg',
    'black card': 'black card.svg',
    'card_empty_front': 'card_empty_front.svg',
    'card_empty_reverse': 'card_empty_reverse.svg',
    'card_loader_front': 'card_loader_front.svg',
    'card_loader_reverse': 'card_loader_reverse.svg',
    'error': 'error.svg',
    'gold card': 'gold card.svg',
    'illustration_actions_new-account': 'illustration_actions_new-account.svg',
    'illustration_confirmation_error': 'illustration_confirmation_error.svg',
    'illustration_confirmation_success': 'illustration_confirmation_success.svg',
    'illustration_confirmation_warning': 'illustration_confirmation_warning.svg',
    'illustration_emptystates_connection-problem': 'illustration_emptystates_connection-problem.svg',
    'illustration_emptystates_error': 'illustration_emptystates_error.svg',
    'illustration_emptystates_maintenance': 'illustration_emptystates_maintenance.svg',
    'illustration_emptystates_no-alerts': 'illustration_emptystates_no-alerts.svg',
    'illustration_emptystates_no-events': 'illustration_emptystates_no-events.svg',
    'illustration_emptystates_no-image': 'illustration_emptystates_no-image.svg',
    'illustration_emptystates_no-items': 'illustration_emptystates_no-items.svg',
    'illustration_emptystates_no-more': 'illustration_emptystates_no-more.svg',
    'illustration_emptystates_no-products': 'illustration_emptystates_no-products.svg',
    'illustration_emptystates_no-results': 'illustration_emptystates_no-results.svg',
    'illustration_emptystates_on-hold': 'illustration_emptystates_on-hold.svg',
    'illustration_emptystates_success': 'illustration_emptystates_success.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-833)
     */
    'illustration_feedback_blocked': 'illustration_feedback_blocked.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-833)
     */
    'illustration_feedback_cancelled': 'illustration_feedback_cancelled.svg',
    'illustration_feedback_cc': 'illustration_feedback_cc.svg',
    'illustration_feedback_error-text-1': 'illustration_feedback_error-text-1.svg',
    'illustration_feedback_error-text': 'illustration_feedback_error-text.svg',
    'illustration_feedback_error': 'illustration_feedback_error.svg',
    'illustration_feedback_informative': 'illustration_feedback_informative.svg',
    'illustration_feedback_off': 'illustration_feedback_off.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-833)
     */
    'illustration_feedback_pending': 'illustration_feedback_pending.svg',
    'illustration_feedback_success': 'illustration_feedback_success.svg',
    'illustration_feedback_warning': 'illustration_feedback_warning.svg',
    'illustration_login_country': 'illustration_login_country.svg',
    'illustration_login_welcome': 'illustration_login_welcome.svg',
    'illustration_notifications_push-ko': 'illustration_notifications_push-ko.svg',
    'illustration_notifications_push-ok': 'illustration_notifications_push-ok.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-869)
     */
    'illustration_payment_mastercard': 'illustration_payment_mastercard.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-869)
     */
    'illustration_payment_visa': 'illustration_payment_visa.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-869)
     */
    'illustration_product_instant-transfer': 'illustration_product_instant-transfer.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-869)
     */
    'illustration_product_travel-plus': 'illustration_product_travel-plus.svg',
    'illustration_security_biocatch': 'illustration_security_biocatch.svg',
    'illustration_security_fraud-alert': 'illustration_security_fraud-alert.svg',
    'illustration_ui_example': 'illustration_ui_example.svg',
    'illustration_ui_image-placeholder': 'illustration_ui_image-placeholder.svg',
    'illustration_ui_placeholder': 'illustration_ui_placeholder.svg',
    'illustration_view_grid': 'illustration_view_grid.svg',
    'illustration_view_list': 'illustration_view_list.svg',
    'illustration_security_face-ID': 'illustration_security_face-ID.svg',
    'illustration_security_camera-declined': 'illustration_security_camera-declined.svg',
    'illustration_security_file-declined': 'illustration_security_file-declined.svg',
    'illustration_security_gallery-declined': 'illustration_security_gallery-declined.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-869)
     */
    'logo_bank_bankofamerica': 'logo_bank_bankofamerica.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-869)
     */
    'logo_bank_chase': 'logo_bank_chase.svg',
    /**
     * @deprecated
     * It is going to be removed (ODSDSWEB-869)
     */
    'logo_bank_citybank': 'logo_bank_citybank.svg',
    'logo_brand_adaptive-1': 'logo_brand_adaptive-1.svg',
    'logo_brand_adaptive': 'logo_brand_adaptive.svg',
    'logo_brand_compact-1': 'logo_brand_compact-1.svg',
    'logo_brand_compact': 'logo_brand_compact.svg',
    'logo_brand_group-1': 'logo_brand_group-1.svg',
    'logo_brand_group': 'logo_brand_group.svg',
    'logo_brand_horizontal-1': 'logo_brand_horizontal-1.svg',
    'logo_brand_horizontal-onsurface-1': 'logo_brand_horizontal-onsurface-1.svg',
    'logo_brand_horizontal-onsurface': 'logo_brand_horizontal-onsurface.svg',
    'logo_brand_horizontal': 'logo_brand_horizontal.svg',
    'logo_brand_isotipo-1': 'logo_brand_isotipo-1.svg',
    'logo_brand_isotipo-fit-1': 'logo_brand_isotipo-fit-1.svg',
    'logo_brand_isotipo-fit': 'logo_brand_isotipo-fit.svg',
    'logo_brand_isotipo': 'logo_brand_isotipo.svg',
    'logo_brand_vertical-1': 'logo_brand_vertical-1.svg',
    'logo_brand_vertical': 'logo_brand_vertical.svg',
    'logo_design-only_brand-launch-1': 'logo_design-only_brand-launch-1.svg',
    'logo_design-only_brand-launch': 'logo_design-only_brand-launch.svg',
    'native_resources_apple-wallet': 'native_resources_apple-wallet.svg',
    'native_resources_appstore-alternative': 'native_resources_appstore-alternative.svg',
    'native_resources_appstore-light': 'native_resources_appstore-light.svg',
    'native_resources_google-wallet': 'native_resources_google-wallet.svg',
    'native_resources_googleplay': 'native_resources_googleplay.svg',
    'PDF': 'PDF.svg',
    'Rectangle1': 'Rectangle1.svg',
    /**
     * @deprecated
     * use "red car" instead
     */
    'redcard': 'redcard.svg',
    'red card': 'red card.svg',
    'Success': 'Success.svg',
    'logo_brand_adaptive-converted': 'logo_brand_adaptive-converted.svg',
    'illustration_feedback_error-text-main-section': 'illustration_feedback_error-text-main-section.svg',
    'logo_brand_isotipo-fit-converted': 'logo_brand_isotipo-fit-converted.svg',
    'illustration_tutorial_step-1': 'illustration_tutorial_step-1.svg',
    'illustration_tutorial_step-2': 'illustration_tutorial_step-2.svg',
    'illustration_tutorial_step-3': 'illustration_tutorial_step-3.svg',
    'illustration_tutorial_step-4': 'illustration_tutorial_step-4.svg',
    'illustration_emptystates_no-contact': 'illustration_emptystates_no-contact.svg',
    'illustration_feedback_error-text_alt': 'illustration_feedback_error-text_alt.svg',
    'illustration_feedback_error-text-main-section_alt': 'illustration_feedback_error-text-main-section_alt.svg',
    'illustration_generic_hidden-products': 'illustration_generic_hidden-products.svg',
    'illustration_generic_no-movements': 'illustration_generic_no-movements.svg',
    'illustration_generic_no-products': 'illustration_generic_no-products.svg',
    'illustration_generic_tag-favorite': 'illustration_generic_tag-favorite.svg',
    'illustration_generic_version-update': 'illustration_generic_version-update.svg',
    'illustration_security_camera-access-declined': 'illustration_security_camera-access-declined.svg',
    'illustration_security_face-id': 'illustration_security_face-id.svg',
    'illustration_security_files-access-declined': 'illustration_security_files-access-declined.svg',
    'illustration_security_fingerprint-id': 'illustration_security_fingerprint-id.svg',
    'illustration_security_gallery-access-declined': 'illustration_security_gallery-access-declined.svg',
    'illustration_cards_add-card': 'illustration_cards_add-card.svg',
    'illustration_cards_card-online': 'illustration_cards_card-online.svg',
    'illustration_payment_pay-bill': 'illustration_payment_pay-bill.svg',
    'illustration_payment_pay-limitless': 'illustration_payment_pay-limitless.svg',
    'patterns_chat_background': 'patterns_chat_background.svg',
    // Native illustrations
    'illustration_native_apple-pay-check-fit': 'illustration_native_apple-pay-check-fit.svg',
    'illustration_native_apple-pay-check': 'illustration_native_apple-pay-check.svg',
    'illustration_native_apple-pay-fit': 'illustration_native_apple-pay-fit.svg',
    'illustration_native_apple-pay': 'illustration_native_apple-pay.svg',
    'illustration_native_google-pay-check-fit': 'illustration_native_google-pay-check-fit.svg',
    'illustration_native_google-pay-check': 'illustration_native_google-pay-check.svg',
    'illustration_native_google-pay-fit': 'illustration_native_google-pay-fit.svg',
    'illustration_native_google-pay': 'illustration_native_google-pay.svg',
    'illustration_native_samsung-pay-check-fit': 'illustration_native_samsung-pay-check-fit.svg',
    'illustration_native_samsung-pay-check': 'illustration_native_samsung-pay-check.svg',
    'illustration_native_samsung-pay-fit': 'illustration_native_samsung-pay-fit.svg',
    'illustration_native_samsung-pay': 'illustration_native_samsung-pay.svg',
    'illustration_native_google-pay-no-stroke': 'illustration_native_google-pay-no-stroke.svg',
    'illustration_native_google-pay-check-no-stroke-fit': 'illustration_native_google-pay-check-no-stroke-fit.svg',
    'illustration_native_google-pay-check-no-stroke': 'illustration_native_google-pay-check-no-stroke.svg',
    'illustration_native_google-pay-no-stroke-fit': 'illustration_native_google-pay-no-stroke-fit.svg',
    'logo_brand_fallback': 'logo_brand_fallback.svg',
    // Samsung illustrations
    'hor_alt': 'hor_alt.svg',
    'hor': 'hor.svg',
    'simple_hor_alt': 'simple_hor_alt.svg',
    'simple_hor': 'simple_hor.svg',
    'simple_ver_alt': 'simple_ver_alt.svg',
    'simple_ver': 'simple_ver.svg',
    'ver_alt': 'ver_alt.svg',
    'ver': 'ver.svg',
    'illustration_generic_time-out': 'illustration_generic_time-out.svg',
    'illustration_generic_expire-session': 'illustration_generic_expire-session.svg',
    'logo_crypto_ada-cardano': 'logo_crypto_ada-cardano.svg',
    'logo_crypto_algo-algorand': 'logo_crypto_algo-algorand.svg',
    'logo_crypto_atom-cosmos': 'logo_crypto_atom-cosmos.svg',
    'logo_crypto_avax-avalanche': 'logo_crypto_avax-avalanche.svg',
    'logo_crypto_btc-bitcoin': 'logo_crypto_btc-bitcoin.svg',
    'logo_crypto_dot-polkadot': 'logo_crypto_dot-polkadot.svg',
    'logo_crypto_eth-ethereum': 'logo_crypto_eth-ethereum.svg',
    'logo_crypto_ltc-litecoin': 'logo_crypto_ltc-litecoin.svg',
    'logo_crypto_mactic-polygon': 'logo_crypto_mactic-polygon.svg',
    'logo_crypto_euro': 'logo_crypto_euro.svg',
    'illustration_actions_cancel-account': 'illustration_actions_cancel-account.svg',
    'illustration_security_safe-data': 'illustration_security_safe-data.svg',
    'illustration_generic_maintenance': 'illustration_generic_maintenance.svg',
    'illustration_security_locked-risk': 'illustration_security_locked-risk.svg',
    'illustration_security_exclamation-risk': 'illustration_security_exclamation-risk.svg',
    'illustration_map_open-santander_design-only': 'illustration_map_open-santander_design-only.svg',
    'illustration_map_santander_design-only': 'illustration_map_santander_design-only.svg',
    'illustration_map_openbank_design-only': 'illustration_map_openbank_design-only.svg',
    'illustration_map_correos_design-only': 'illustration_map_correos_design-only.svg',
    'illustration_map_fallback': 'illustration_map_fallback.svg',
    'logo_crypto_btc-eth': 'logo_crypto_btc-eth.svg',
    'illustration_id_spain-cue': 'illustration_id_spain-cue.svg',
    'illustration_id_spain-nie': 'illustration_id_spain-nie.svg',
    'illustration_id_spain-passport': 'illustration_id_spain-passport.svg',
    'illustration_id_spain': 'illustration_id_spain.svg',
    'illustration_notifications_desktop-push-ok': 'illustration_notifications_desktop-push-ok.svg',
    'illustration_notifications_desktop-push-ko': 'illustration_notifications_desktop-push-ko.svg',
    'logo_corporate_powered-by-google': 'logo_corporate_powered-by-google.svg',
    'illustration_confirmation_pending': 'illustration_confirmation_pending.svg',
    'illustration_generic_discount': 'illustration_generic_discount.svg',
    'illustration_native_apple-pay-bg': 'illustration_native_apple-pay-bg.svg',
    'illustration_native_google-pay-bg': 'illustration_native_google-pay-bg.svg',
    'illustration_native_samsung-pay-bg': 'illustration_native_samsung-pay-bg.svg',
    'illustration_native_google-pay-no-stroke-bg': 'illustration_native_google-pay-no-stroke-bg.svg',
    'illustration_promotional_sent': 'illustration_promotional_sent.svg',
    'illustration_promotional_completed': 'illustration_promotional_completed.svg',
    'illustration_promotional_redeemed': 'illustration_promotional_redeemed.svg',
};
export const RELOADED_ILLUSTRATIONS = (() => {
    const result = {};
    Object.keys(ILLUSTRATIONS_STYLES).forEach(illustration => {
        result[illustration] = illustration;
    });
    return result;
})();
//# sourceMappingURL=illustrations.js.map